import { render, staticRenderFns } from "./ProduzioneLayoutColumn.vue?vue&type=template&id=f2eb39f6&scoped=true&"
import script from "./ProduzioneLayoutColumn.vue?vue&type=script&lang=js&"
export * from "./ProduzioneLayoutColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2eb39f6",
  null
  
)

export default component.exports